import { OptionCard, StepBody, StepHeader, StepNav } from "./HikvisionWizardParts";

const ZONE_OPTIONS = [
    { value: true, title: "Yes", subtitle: "Control the Hikvision using zones" },
    { value: false, title: "No", subtitle: "Control the Hikvision without zones" },
];

// wantsZones: null until the user picks Yes/No
const HikvisionStepZones = ({ wantsZones, setWantsZones, onNext, onBack, isLastStep }) => (
    <>
        <StepHeader title="Do you want to set up zones?" />
        <StepBody>
            {ZONE_OPTIONS.map(option => (
                <OptionCard
                    key={option.title}
                    radio
                    title={option.title}
                    subtitle={option.subtitle}
                    selected={wantsZones === option.value}
                    onClick={() => setWantsZones(option.value)}
                />
            ))}
        </StepBody>
        <StepNav
            onBack={onBack}
            onNext={onNext}
            nextDisabled={wantsZones == null}
            nextLabel={isLastStep ? "Link Hikvision" : "Next"}
            nextIcon={isLastStep ? "pi pi-link" : "pi pi-arrow-right"}
        />
    </>
);

export default HikvisionStepZones;
